function requireAuth(to, from, next) {
  $.ajax({
    url: api_url + 'users/checkLogin',
    method: 'post',
    dataType: 'json',
    success: function (response) {
      if (response.success) {
        next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }
  });
}

import Vue from 'vue';
import VueRouter from 'vue-router';
import components from './components/components.vue';
import App from './components/app.vue'
import Test from './components/test.vue';
import Home from './components/home.vue';
import Login from './components/login.vue';
import Logout from './components/logout.vue';
import Message from './components/message.vue';
import Users from './components/users.vue';
import User from './components/user.vue';
import CardOwners from './components/cardowners.vue';
import CardOwner from './components/cardowner.vue';
import Cards from './components/cards.vue';
import Log from './components/log.vue';
import Card from './components/card.vue';
import Maintenance from './components/maintenance.vue';
import ShibLogin from './components/shiblogin.vue';

Vue.use(VueRouter)

const router = new VueRouter({
  //mode: 'history',
  //base: '/Kartyarendszer3/',
  base: __dirname,
  routes: [
    { path: '*', component: Home, beforeEnter: requireAuth },
    { path: '/test', component: Test, beforeEnter: requireAuth },
    { path: '/users/list', component: Users, beforeEnter: requireAuth },
    { path: '/user/edit', component: User, beforeEnter: requireAuth },
    { path: '/card_owners/list', component: CardOwners, beforeEnter: requireAuth },
    { path: '/card_owner/edit', component: CardOwner, beforeEnter: requireAuth },
    { path: '/card/list', component: Cards, beforeEnter: requireAuth },
    { path: '/card/edit', component: Card, beforeEnter: requireAuth },
    { path: '/maintenance', component: Maintenance, beforeEnter: requireAuth },
    { path: '/log', component: Log, beforeEnter: requireAuth },
    { path: '/msg', component: Message },
    { path: '/login', component: Login },
    { path: '/shiblogin', component: ShibLogin },
    { path: '/logout', component: Logout }
  ]
});

window.api_url = 'api/';

new Vue({
  data: {
    version: '1.0.2024.04.09.14.10',
    user: {},
    pageMsg: {
      type: '',
      text: ''
    },
    socket: ''
  },
  mounted: function () {
    var _this = this;
    $.ajax({
      url: api_url + 'users/checkLogin',
      method: 'post',
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          _this.user = response.user;
        }
      }
    });
  },
  methods: {
    checkRule: function (rule_alias) {
      var in_arr = false;

      if (this.user.rules != undefined && this.user.rules.length > 0) {
        this.user.rules.map(function (rule, i) {
          if (rule == rule_alias)
            in_arr = true;
        });
      }

      return in_arr;
    },
    checkCardRule: function (rule_id) {
      var in_arr = false;

      if (this.user.card_rules != undefined && this.user.card_rules.length > 0) {
        this.user.card_rules.map(function (card_rule_id, i) {
          if (parseInt(card_rule_id) == parseInt(rule_id))
            in_arr = true;
        });
      }

      return in_arr;
    },
    ajax: function (url, user_options) {
      var _this = this;

      // Verzió ellenőrzés
      $.ajax({
        url: api_url + 'getVersion',
        method: 'post',
        data: {
          version: _this.version
        },
        dataType: 'json',
        success: function (response) {
          if (response.status == 'ERROR') {
            swal('Figyelem', response.msg, 'error');
            return;
          } else {
            _this.callajax(url, user_options);
          }
        }
      });
    },
    callajax: function (url, user_options) {
      var _this = this;

      var options = {
        method: 'GET',
        dataType: 'json',
        data: {},
        async: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        processData: true,
        success: function () { },
        error: function () { }
      };

      var options = $.extend({}, options, user_options);

      try {
        if (url == undefined)
          throw 'Url hiányzik';

        $.ajax({
          method: options.method,
          url: api_url + url,
          async: options.async,
          data: options.data,
          timeout: 1800000,
          dataType: options.dataType,
          error: options.error,
          contentType: options.contentType,
          processData: options.processData,
          beforeSend: options.beforeSend ? options.beforeSend : () => { },
          success: function (response) {
            if (response.status == "OK") {
              options.success(response);

            } else if (response.status == "NO_ACCESS") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Nincs joga a művelethez'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "DATABASE_ERROR") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: response.text
              };
              _this.$router.push({ path: '/msg' });
            }
          }
        });

      } catch (error) {
        alert(error);
      }
    }
  },
  router,
  render: h => h(App)
}).$mount('#app-container');



// WEBPACK FOOTER //
// ./main.js